import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.css']
})
export class LicensesComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
    this.title.setTitle("Licenses - SingX");
    this.canonicalService.updateCanonicalUrl('/licenses');
    this.meta.updateTag({ name: 'description', content: 'SingX helps you to transfer Money Globally. We are a proud winner of the MAS Global FinTech Awards 2017. We work with licensed remittance operators in each country.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Money to India Exchange Rate, best money transfer to India, how to transfer money to India, best way to Send Money Overseas, remit to India rates, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
  }

  ngOnInit(): void {
  }

}
